import React from "react";

export const replaceIncorrectSymbols = (string) => {
  return string.replace(/â€\x9D/, "").replace(/\//, "").replace("”", "")
}

/**
 * @param value {number}
 * @param percent {number}
 * @returns {number}
 */
export const getPercentage = (value, percent) => {
  return (value / 100) * percent;
}

/**
 * @param value {number}
 * @param fromTotal {number}
 * @returns {number} %
 */
export const getPercentAmount = (value, fromTotal) => {
  if (!value) {
    return 0
  }
  return (fromTotal / value) * 100;
}

/**
 * common func for checking if need to show
 * @param fabricatorSettings {object}
 * @param forCartItems {array}
 * @return {array} // {currency: "USD", cartItems: []}
 */
export const getDifferentCurrencyCartItems = (fabricatorSettings, forCartItems = []) => {
  let totalArray = [];
  if (!fabricatorSettings.useDifferentCurrencies || !forCartItems.length) {
    return totalArray
  }
  forCartItems.forEach(cartItem => {
    if (cartItem.cartFeature && cartItem.cartFeature.getFeatureCurrency) {
      const featureCurrency = cartItem.cartFeature.getFeatureCurrency();
      if (featureCurrency && (featureCurrency !== fabricatorSettings.currency)) {
        const existingGroup = totalArray.find(filterGroupObject => {
          return filterGroupObject.currency === featureCurrency
        });
        if (existingGroup) {
          existingGroup.cartItems.push(cartItem);
        } else {
          totalArray.push({
            currency: featureCurrency,
            cartItems: [cartItem]
          })
        }
      }
    }
  });
  // console.log("totalArray", totalArray);
  return totalArray
}

/**
 * highlights search text in the name
 * @param finalName {string}
 * @param searchText {string}
 * @return {string}
 */
export const highlightStringOnSearch = (finalName, searchText) => {
  if (!searchText) {
    return finalName
  }
  const escapedSearch = searchText.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
  const regex = new RegExp(escapedSearch, "gi"); // Case-insensitive search
  return <span dangerouslySetInnerHTML={{
    __html: finalName.replace(regex, (match) => {
      return `<span class="color-secondary_active">${match}</span>`
    })
  }}/>
}
